module.exports = __webpack_public_path__ + "static/logo-outlined-min-e263b624db629952c211b55b86c686e9.webp";